// src/components/VideoAnalyseConsent.js

import React, { useState } from 'react';
import useVideoBewaartermijn from '../hooks/useVideoBewaartermijn';

function VideoAnalyseConsent({ onConsent }) {
  const [checked, setChecked] = useState({
    toestemming: false,
    aiVerwerking: false,
    bewaren: false,
  });
  const [saving, setSaving] = useState(false);
  // Akkoord gaan kan pas als de tekst de termijn noemt.
  const bewaartermijn = useVideoBewaartermijn();

  const allChecked = checked.toestemming && checked.aiVerwerking && checked.bewaren && Boolean(bewaartermijn);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!allChecked || saving) return;
    setSaving(true);
    await onConsent();
    setSaving(false);
  }

  function toggle(key) {
    setChecked(prev => ({ ...prev, [key]: !prev[key] }));
  }

  return (
    <div className="page-container video-analyse-page">
      <div className="page-introduction">
        <h1>Video Analyse</h1>
        <p>Upload een video van je les en krijg feedback van de AI.</p>
      </div>
      <main className="video-analyse-content">
        <div className="consent-card">
          <div className="consent-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="4" y="8" width="40" height="32" rx="4" stroke="currentColor" strokeWidth="2.5" fill="none"/>
              <path d="M18 28l4 4 8-10" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
            </svg>
          </div>

          <h2>Voordat je begint</h2>
          <p className="consent-intro">
            Bij video-analyse bekijkt de AI een video van je les. Zo'n video kan persoonsgegevens bevatten. Lees daarom de punten hieronder en vink ze aan.
          </p>

          <form onSubmit={handleSubmit}>
            <label className="consent-checkbox" onClick={() => toggle('toestemming')}>
              <span className={`consent-check${checked.toestemming ? ' checked' : ''}`}>
                {checked.toestemming && <span>&#10003;</span>}
              </span>
              <span>
                <strong>Toestemming geregeld</strong><br/>
                Mijn schoolleiding vindt het goed dat ik mijn les film voor mijn eigen ontwikkeling. Ik volg de regels van mijn school over filmen. Zijn er leerlingen of anderen te zien of te horen, dan is daar toestemming voor. Ik richt de camera op mezelf en houd leerlingen zo min mogelijk herkenbaar. In de extra context noem ik geen namen van leerlingen.
              </span>
            </label>

            <label className="consent-checkbox" onClick={() => toggle('aiVerwerking')}>
              <span className={`consent-check${checked.aiVerwerking ? ' checked' : ''}`}>
                {checked.aiVerwerking && <span>&#10003;</span>}
              </span>
              <span>
                <strong>AI-verwerking</strong><br/>
                Google Gemini (AI) bekijkt en beluistert mijn video binnen de EU om het rapport te maken. Mijn video wordt alleen daarvoor gebruikt, niet om AI-modellen te trainen. We bewaren geen uitgeschreven tekst van wat er gezegd wordt.
              </span>
            </label>

            <label className="consent-checkbox" onClick={() => toggle('bewaren')}>
              <span className={`consent-check${checked.bewaren ? ' checked' : ''}`}>
                {checked.bewaren && <span>&#10003;</span>}
              </span>
              <span>
                <strong>Bewaren en toegang</strong><br/>
                We verwijderen mijn video vanzelf {bewaartermijn?.woorden ?? '…'} na het uploaden. Het rapport blijft zolang mijn account bestaat. Ik kan de analyse eerder zelf verwijderen. Voor de video-analyse vul ik naast mijn wachtwoord een code in die ik per mail krijg.
              </span>
            </label>

            <div className="consent-info">
              <strong>Goed om te weten</strong>
              <ul>
                <li>Je video staat in een afgeschermde opslag in Nederland (Google Cloud). Alleen jij kunt hem bekijken, via je account.</li>
                <li>Niemand anders met een account ziet je rapport. Beheerders van Doorloopjes kunnen erbij voor onderhoud, onder geheimhouding.</li>
                <li>Het rapport gaat over wat jij doet als leraar, niet over losse leerlingen.</li>
                <li>Verder geldt de privacyverklaring van Doorloopjes (onderaan de homepage).</li>
              </ul>
            </div>

            <button
              type="submit"
              className="btn-primary-action"
              disabled={!allChecked || saving}
            >
              {saving ? 'Opslaan...' : 'Ik ga akkoord, naar video-analyse'}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}

export default VideoAnalyseConsent;
